'use client';

// Third Party
import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';

// Utils
import { imagekitLoader } from '@utils/imagekit-loader';
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';

// UI
import { Alphatar } from '@components/alphatar';
export type IAvatarProps = {
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  linkTo?: string;
  sizes?: string;
  shape: 'circle' | 'square';
};
export const Avatar: React.FC<IAvatarProps> = t0 => {
  const $ = _c(25);
  const {
    firstName,
    lastName,
    avatarUrl,
    linkTo,
    sizes,
    shape
  } = t0;
  let t1;
  if ($[0] !== firstName || $[1] !== lastName) {
    t1 = () => {
      if (firstName && lastName) {
        return `${firstName} ${lastName}'s profile picture`;
      } else {
        if (firstName) {
          return `${firstName}'s profile picture`;
        }
      }
      return "User profile picture";
    };
    $[0] = firstName;
    $[1] = lastName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getAltText = t1;
  if (linkTo) {
    if (avatarUrl) {
      const t2 = getAltText();
      let t3;
      if ($[3] !== avatarUrl || $[4] !== sizes || $[5] !== t2) {
        t3 = <Image fill={true} src={avatarUrl} alt={t2} placeholder="blur" className="object-center object-cover" loader={imagekitLoader} blurDataURL={GRAY_PIXEL_DATA_URL} sizes={sizes} />;
        $[3] = avatarUrl;
        $[4] = sizes;
        $[5] = t2;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      let t4;
      if ($[7] !== linkTo || $[8] !== t3) {
        t4 = <div className="relative overflow-hidden h-full hover:opacity-70 aspect-1 bg-white rounded-full"><a href={linkTo} target="_blank" rel="noreferrer">{t3}</a></div>;
        $[7] = linkTo;
        $[8] = t3;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      return t4;
    } else {
      let t2;
      if ($[10] !== firstName || $[11] !== lastName || $[12] !== shape) {
        t2 = <Alphatar firstName={firstName} lastName={lastName} shape={shape} />;
        $[10] = firstName;
        $[11] = lastName;
        $[12] = shape;
        $[13] = t2;
      } else {
        t2 = $[13];
      }
      let t3;
      if ($[14] !== linkTo || $[15] !== t2) {
        t3 = <a className="hover:opacity-70 w-full h-full" href={linkTo} target="_blank" rel="noreferrer">{t2}</a>;
        $[14] = linkTo;
        $[15] = t2;
        $[16] = t3;
      } else {
        t3 = $[16];
      }
      return t3;
    }
  }
  if (avatarUrl) {
    const t2 = getAltText();
    let t3;
    if ($[17] !== avatarUrl || $[18] !== sizes || $[19] !== t2) {
      t3 = <div className="relative overflow-hidden h-full aspect-1 bg-white rounded-full"><Image fill={true} src={avatarUrl} alt={t2} placeholder="blur" className="object-center object-cover" loader={imagekitLoader} blurDataURL={GRAY_PIXEL_DATA_URL} sizes={sizes} /></div>;
      $[17] = avatarUrl;
      $[18] = sizes;
      $[19] = t2;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    return t3;
  } else {
    let t2;
    if ($[21] !== firstName || $[22] !== lastName || $[23] !== shape) {
      t2 = <div className="w-full h-full"><Alphatar firstName={firstName} lastName={lastName} shape={shape} /></div>;
      $[21] = firstName;
      $[22] = lastName;
      $[23] = shape;
      $[24] = t2;
    } else {
      t2 = $[24];
    }
    return t2;
  }
};